import { get } from 'lodash';
import { EnvironmentCluster } from 'libs.react';
export const isChinaCluster = (environment) => {
    return [EnvironmentCluster.CN_DEV, EnvironmentCluster.CN_PROD, EnvironmentCluster.CN_ALI_PLATFORM].includes(environment?.deployment?.cluster);
};
export const getMoaBaseUrl = (environment) => {
    const deploymentCluster = environment.deployment?.cluster;
    const environmentCluster = environment.cluster;
    const prodClusters = ['prod', 'eu1', 'dev', 'eu1-dev'];
    const chinaProdClusters = ['cn1', 'cn1-dev'];
    //  Check for china cluster and return appropriate url
    if (chinaProdClusters.includes(deploymentCluster) || chinaProdClusters.includes(environmentCluster)) {
        return 'api.medable.cn';
    }
    //  Check for prod cluster and return appropriate url
    if (prodClusters.includes(deploymentCluster) || prodClusters.includes(environmentCluster)) {
        return 'api.medable.com';
    }
    // Ephemeral environments should use production API when created from production Studio
    if (environment.deployment?.type === 'ephemeral' &&
        (deploymentCluster === 'ephemeral' || environmentCluster === 'ephemeral')) {
        return process.env.STUDIO_ENV === 'production' ? 'api.medable.com' : 'api-int-dev.medable.com';
    }
    //  Return default url
    return 'api-int-dev.medable.com';
};
export const getFinalUrl = (baseURL, encoded) => {
    return `https://${baseURL}/moa/routes/moa/gen/${encoded}`;
};
export const getStudyShortCode = async (environment) => {
    const moaBaseUrl = getMoaBaseUrl(environment);
    const { cortexURL, code } = environment;
    const cortexHostname = cortexURL.replace('https://', '');
    const encoded = encodeURIComponent(`${cortexHostname}/${code}`);
    const fetchResponse = await fetch(getFinalUrl(moaBaseUrl, encoded));
    const response = await fetchResponse.json();
    return response?.data;
};
export const getOnboardingConfig = (study) => {
    const studyConfig = get(study, 'c_menu_config', []);
    return studyConfig.find((config) => config.c_menu === 'subject_onboarding');
};
/*
  cortexAPI urls: https://gitlab.medable.com/platform/services/mom/-/blob/main/config.json#L34-39
  webapp urls: https://gitlab.medable.com/devops/ops/-/blob/main/shared/nix/services/cortex/cortex/hosts.map.yaml
 */
export const extractClassicAppsBaseUrl = (cortexUrl, appName) => {
    const url = new URL(cortexUrl);
    const { hostname } = url;
    // Extract the environment part between 'api' and '.medable' and TLD
    const envMatch = hostname.match(/^api([.-])?(.*)\.medable\.(com|cn|tech)$/);
    if (!envMatch) {
        return `https://${appName}.medable.com`;
    }
    const [, , env = '', tld] = envMatch;
    // Production US/CN environments won't have env
    if (!env) {
        return `https://${appName}.medable.${tld}`;
    }
    // Determine the separator to use based on environment and app name
    let separator = '-'; // Default separator
    switch (true) {
        case env === 'local':
            separator = '.';
            break;
        // portal/mystudy in qa/dev in non-CN environments use dot for legacy reasons
        case (appName === 'portal' || appName === 'mystudy') && (env === 'qa' || env === 'dev') && tld !== 'cn':
            separator = '.';
            break;
        default:
            separator = '-';
    }
    return `https://${appName}${separator}${env}.medable.${tld}`;
};
